module.exports = __webpack_public_path__ + "img/national14.5fa9af42.png";